import React from 'react';
import HolidayContainer from '../../containers/holidayMng/HolidayMngContainer';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const HolidayMngPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="영업활동관리/휴일관리" icon="partner" />
      <HolidayContainer />
    </>
  );
};

export default HolidayMngPage;
